import { create } from "zustand";

const useSelectedProductStore = create((set) => ({
  isLlmWhisperer: window.location.pathname.startsWith("/llm-whisperer"),
  setIsLlmWhisperer: (isLlmWhisperer) => set({ isLlmWhisperer }),
  isVerticals: window.location.pathname.startsWith("/verticals"),
  setIsVerticals: (isVerticals) => set({ isVerticals }),
  selectedProduct: localStorage.getItem("selectedProduct") || null,
  resetSelectedProduct: () =>
    set(() => {
      localStorage.removeItem("selectedProduct");
      return { selectedProduct: null };
    }),
  setSelectedProduct: (product) =>
    set((state) => {
      localStorage.setItem("selectedProduct", product);
      return { selectedProduct: product };
    }),
}));

export { useSelectedProductStore };
